import { render, staticRenderFns } from "./AWSPartner.vue?vue&type=template&id=05510a9a&scoped=true"
import script from "./AWSPartner.vue?vue&type=script&lang=js"
export * from "./AWSPartner.vue?vue&type=script&lang=js"
import style0 from "./AWSPartner.vue?vue&type=style&index=0&id=05510a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05510a9a",
  null
  
)

export default component.exports